module.exports = __webpack_public_path__ + "img/blog-19-1.54b322d5.webp";